import { all, call, put, takeEvery, fork } from 'redux-saga/effects';
import { fetchJSON } from '../../helpers/api';
import {
  getSecuritiesSuccess,
  getSecuritiesFailure,
  getSecuritySuccess,
  getSecurityFailure,
} from './actions';
import {
  GET_SECURITIES,
  GET_SECURITY,
} from './constants';

const SERVER_URL = process.env.REACT_APP_KDM_API_ENDPOINT;

//GetAllSecurities
function* getSecuritiesSaga() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetSecuritiesDashboard`, options);
    yield put(getSecuritiesSuccess(response));
  } catch (error) {
    let message;
    if (error.statusCode) {
      const errorDesc = (error.error && error.error.description) ? error.error.description : null;
      switch (error.statusCode) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
          break;
        default:
          message = errorDesc || 'An error occurred';
      }
    } else {
      message = (error.description || 'An unknown error occurred');
    }
    yield put(getSecuritiesFailure(message));
  }
}

// Get Security
function* getSecuritySaga({ payload: { securityId } }) {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetSecuritiesDetails/${securityId}`, options);
    yield put(getSecuritySuccess(response));
  } catch (error) {
    let message;
    if (error.statusCode) {
      const errorDesc = (error.error && error.error.description) ? error.error.description : null;
      switch (error.statusCode) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
          break;
        default:
          message = errorDesc || 'An error occurred';
      }
    } else {
      message = (error.description || 'An unknown error occurred');
    }
    yield put(getSecurityFailure(message));
  }
}
/**
 * Watchers
 */
export function* watchGetSecurities() {
  yield takeEvery(GET_SECURITIES, getSecuritiesSaga);
}
export function* watchGetSecurity() {
  yield takeEvery(GET_SECURITY, getSecuritySaga);
}

function* SecuritySaga() {
  yield all([
    fork(watchGetSecurities),
    fork(watchGetSecurity),
  ]);
}

export default SecuritySaga;
